export default "__VITE_ASSET__C018Vtqd__"